/**
 * Convivium — Marketplace Page JS
 * Carousel, box detail modal, add-to-cart with Horizon theme integration
 */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Helpers ──────────────────────────────────────────────────────── */

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + ' \u20AC';
  }

  /* Il riquadro sta in cv-carrello.js, che il layout carica su ogni pagina.
     Prima ogni file aveva la sua copia di questa funzione: tre copie identiche
     che il giorno che se ne cambiava una sola cominciavano a divergere. */
  function showToast(msg, isError) {
    if (window.Convivium && window.Convivium.toast) window.Convivium.toast(msg, isError);
  }

  /** Dispatch Horizon's cart:update so cart-icon, cart-drawer, etc. refresh */
  function dispatchCartUpdate(cart, totalQty) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'marketplace-box',
        data: {
          source: 'marketplace-box',
          itemCount: cart ? cart.item_count : totalQty,
        },
      },
    }));
  }

  /* ── Carousel ────────────────────────────────────────────────────── */

  var track = document.querySelector('.mp-boxes__track');
  var prevBtn = document.querySelector('.mp-boxes__arrow--prev');
  var nextBtn = document.querySelector('.mp-boxes__arrow--next');
  var cards = document.querySelectorAll('.mp-box-card');
  var GAP = 24;

  if (cards.length <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
  }

  function updateArrows() {
    if (!track || !prevBtn || !nextBtn) return;
    prevBtn.disabled = track.scrollLeft <= 0;
    nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 10;
  }

  function scrollTrack(dir) {
    if (!track) return;
    var step = (cards[0] ? cards[0].offsetWidth : 300) + GAP;
    track.scrollBy({ left: step * dir, behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { scrollTrack(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollTrack(1); });
  if (track) {
    var scrollT = null;
    track.addEventListener('scroll', function () {
      if (scrollT) clearTimeout(scrollT);
      scrollT = setTimeout(updateArrows, 100);
    });
  }
  updateArrows();

  /* ── Modal refs ──────────────────────────────────────────────────── */

  var overlay     = document.getElementById('mp-modal-overlay');
  var modalImg    = document.getElementById('mp-modal-image');
  var modalTitle  = document.getElementById('mp-modal-title');
  var modalDesc   = document.getElementById('mp-modal-desc');
  var modalList   = document.getElementById('mp-modal-products');
  var modalQtyEl  = document.getElementById('mp-modal-qty');
  var modalMinus  = overlay ? overlay.querySelector('.mp-modal__qty-minus') : null;
  var modalPlus   = overlay ? overlay.querySelector('.mp-modal__qty-plus') : null;
  var modalAddBtn = document.getElementById('mp-modal-add');
  var modalAddTxt = document.getElementById('mp-modal-add-text');

  var mQty = 1;
  var mBasePrice = 0;
  var mProducts = [];
  var mBoxTitle = '';

  /* ── Modal logic ─────────────────────────────────────────────────── */

  function recomputeBoxTotal() {
    if (!mProducts.length) return;
    mBasePrice = mProducts.reduce(function (sum, p) {
      return sum + p.price * p.qty;
    }, 0);
  }

  function updateModalUI() {
    if (modalQtyEl) modalQtyEl.textContent = mQty;
    if (modalMinus) modalMinus.disabled = mQty <= 1;
    if (modalAddTxt) {
      modalAddTxt.textContent = 'Aggiungi Box \u2013 ' + formatMoney(mBasePrice * mQty);
    }
  }

  function openModal(card) {
    if (!overlay) return;

    var image = card.getAttribute('data-box-image') || '';
    mBoxTitle = card.getAttribute('data-box-title') || '';
    mBasePrice = parseInt(card.getAttribute('data-box-price'), 10) || 0;
    mQty = 1;

    try { mProducts = JSON.parse(card.getAttribute('data-box-products') || '[]'); }
    catch (_) { mProducts = []; }

    modalTitle.textContent = mBoxTitle;
    modalDesc.textContent  = card.getAttribute('data-box-desc') || '';

    if (image) {
      modalImg.src = image;
      modalImg.alt = modalTitle.textContent;
      modalImg.parentElement.style.display = '';
    } else {
      modalImg.parentElement.style.display = 'none';
    }

    // Build product rows
    modalList.innerHTML = '';
    mProducts.forEach(function (p) {
      var li = document.createElement('li');
      li.className = 'mp-modal__product-row';

      var qty = document.createElement('span');
      qty.className = 'mp-modal__product-qty';
      qty.textContent = p.qty + '\u00D7';

      var name = document.createElement('span');
      name.className = 'mp-modal__product-name';
      name.textContent = p.title;

      var price = document.createElement('span');
      price.className = 'mp-modal__product-price';
      price.textContent = formatMoney(p.price);

      var hasChoice = p.variants && p.variants.length > 1;
      if (!hasChoice && p.variant && p.variant !== 'Default Title') {
        var v = document.createElement('span');
        v.className = 'mp-modal__product-variant';
        v.textContent = ' (' + p.variant + ')';
        name.appendChild(v);
      }

      if (hasChoice) {
        var selLabel = document.createElement('span');
        selLabel.className = 'mp-modal__variant-label';
        selLabel.setAttribute('aria-hidden', 'true');
        selLabel.textContent = 'Formato';
        var sel = document.createElement('select');
        sel.className = 'mp-modal__variant';
        sel.setAttribute('aria-label', 'Formato di ' + p.title);
        p.variants.forEach(function (vv) {
          var o = document.createElement('option');
          o.value = String(vv.id);
          o.textContent = vv.title + (vv.available ? '' : ' · esaurito');
          if (!vv.available) o.disabled = true;
          if (vv.id === p.id) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () {
          var chosen = null;
          p.variants.forEach(function (vv) {
            if (String(vv.id) === sel.value) chosen = vv;
          });
          if (!chosen) return;
          p.id = chosen.id;
          p.price = chosen.price;
          p.variant = chosen.title;
          price.textContent = formatMoney(chosen.price);
          recomputeBoxTotal();
          updateModalUI();
        });
        li.append(qty, name, selLabel, sel, price);
      } else {
        li.append(qty, name, price);
      }
      modalList.appendChild(li);
    });

    if (window.mpEnhanceVariantSelects) window.mpEnhanceVariantSelects(modalList);

    recomputeBoxTotal();
    updateModalUI();
    overlay.classList.add('mp-modal-overlay--open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!overlay) return;
    overlay.classList.remove('mp-modal-overlay--open');
    document.body.style.overflow = '';
  }

  // Close handlers
  if (overlay) {
    document.getElementById('mp-modal-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  // Qty handlers
  if (modalMinus) modalMinus.addEventListener('click', function () {
    if (mQty > 1) { mQty--; updateModalUI(); }
  });
  if (modalPlus) modalPlus.addEventListener('click', function () {
    if (mQty < 10) { mQty++; updateModalUI(); }
  });

  /* ── Card click → modal ──────────────────────────────────────────── */

  cards.forEach(function (card) {
    card.style.cursor = 'pointer';
    card.addEventListener('click', function () { openModal(card); });
  });

  /* ── Add to cart ─────────────────────────────────────────────────── */

  if (modalAddBtn) {
    modalAddBtn.addEventListener('click', async function () {
      if (!mProducts.length) return;

      var items = mProducts.map(function (p) {
        return {
          id: p.id,
          quantity: p.qty * mQty,
          properties: { 'Box': mBoxTitle, '_box_name': mBoxTitle, '_produttore': p.vendor || '' },
        };
      });

      modalAddBtn.classList.add('mp-modal__add-btn--loading');
      if (modalAddTxt) modalAddTxt.textContent = 'Aggiunta...';
      modalAddBtn.disabled = true;

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        });

        if (!res.ok) {
          var err = await res.json().catch(function () { return {}; });
          throw new Error(err.description || err.message || 'Cart error');
        }

        // Fetch fresh cart to get accurate item_count
        var cartRes = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
        var cart = cartRes.ok ? await cartRes.json() : null;

        // Notify Horizon theme (cart-icon, cart-drawer, etc.)
        dispatchCartUpdate(cart, 0);

        showToast('Box aggiunto al carrello');
        closeModal();

      } catch (e) {
        showToast(e.message || 'Errore: riprova', true);
      } finally {
        modalAddBtn.classList.remove('mp-modal__add-btn--loading');
        modalAddBtn.disabled = false;
        updateModalUI();
      }
    });
  }

  /* ══════════════════════════════════════════════════════════════════
     PRODUCTS SECTION — Filters, Sort, Add-to-cart
     ══════════════════════════════════════════════════════════════════ */

  /* ── Custom brand listbox (progressive enhancement of native selects) ──
     The native <select> stays in the DOM (hidden) as the single source of
     truth: choosing an option sets select.value and fires 'change', so all
     filter/sort/chips/reset logic below is untouched. External code that
     sets select.value directly must call select._mpSelectSync() after. */
  function enhanceSelects() {
    var openWidget = null;
    var uid = 0;

    document.addEventListener('click', function (e) {
      if (openWidget && !openWidget.root.contains(e.target)) openWidget.close();
    });
    document.addEventListener('mp:close-selects', function () {
      if (openWidget) openWidget.close();
    });

    document.querySelectorAll('.mp-filter-group__select, #mp-sort').forEach(enhance);

    function enhance(sel) {
      var id = 'mp-select-' + (++uid);
      var root = document.createElement('div');
      root.className = 'mp-select' + (sel.id === 'mp-sort' ? ' mp-select--inline' : '');
      sel.parentNode.insertBefore(root, sel);
      root.appendChild(sel);
      sel.classList.add('mp-select__native');
      sel.tabIndex = -1;
      sel.setAttribute('aria-hidden', 'true');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mp-select__btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML =
        '<span class="mp-select__value" id="' + id + '-value"></span>' +
        '<svg class="mp-select__chevron" width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var group = root.closest('.mp-filter-group');
      var groupLabel = group ? group.querySelector('.mp-filter-group__label') : null;
      if (groupLabel) {
        if (!groupLabel.id) groupLabel.id = id + '-label';
        btn.setAttribute('aria-labelledby', groupLabel.id + ' ' + id + '-value');
      } else if (sel.getAttribute('aria-label')) {
        btn.setAttribute('aria-label', sel.getAttribute('aria-label'));
      }

      var list = document.createElement('ul');
      list.className = 'mp-select__list';
      list.id = id + '-list';
      list.setAttribute('role', 'listbox');
      list.tabIndex = -1;
      if (groupLabel) list.setAttribute('aria-labelledby', groupLabel.id);
      btn.setAttribute('aria-controls', list.id);

      var options = Array.from(sel.options).map(function (opt, i) {
        var li = document.createElement('li');
        li.className = 'mp-select__option';
        li.id = id + '-opt-' + i;
        li.setAttribute('role', 'option');
        li.innerHTML =
          '<span class="mp-select__option-text"></span>' +
          '<svg class="mp-select__option-check" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        li.firstChild.textContent = opt.text;
        li.addEventListener('click', function () { choose(i); });
        li.addEventListener('mousemove', function () { if (activeIndex !== i) setActive(i); });
        list.appendChild(li);
        return li;
      });

      root.appendChild(btn);
      root.appendChild(list);

      var activeIndex = -1;
      var typeahead = '';
      var typeTimer = null;

      function sync() {
        var i = sel.selectedIndex < 0 ? 0 : sel.selectedIndex;
        var valueEl = document.getElementById(id + '-value');
        if (valueEl && sel.options[i]) valueEl.textContent = sel.options[i].text;
        options.forEach(function (li, j) {
          li.setAttribute('aria-selected', j === i ? 'true' : 'false');
        });
      }

      function setActive(i) {
        activeIndex = Math.max(0, Math.min(i, options.length - 1));
        options.forEach(function (li, j) {
          li.classList.toggle('mp-select__option--active', j === activeIndex);
        });
        list.setAttribute('aria-activedescendant', options[activeIndex].id);
        options[activeIndex].scrollIntoView({ block: 'nearest' });
      }

      function open() {
        if (openWidget && openWidget.root !== root) openWidget.close();
        /* Drop up when the viewport space below can't fit the list */
        var estH = Math.min(options.length * 44 + 12, 264);
        var rect = btn.getBoundingClientRect();
        var below = window.innerHeight - rect.bottom;
        root.classList.toggle('mp-select--up', below < estH + 16 && rect.top > below);
        root.classList.add('mp-select--open');
        btn.setAttribute('aria-expanded', 'true');
        setActive(sel.selectedIndex < 0 ? 0 : sel.selectedIndex);
        list.focus();
        openWidget = { root: root, close: close };
      }

      function close(refocus) {
        root.classList.remove('mp-select--open');
        btn.setAttribute('aria-expanded', 'false');
        if (openWidget && openWidget.root === root) openWidget = null;
        if (refocus) btn.focus();
      }

      function choose(i) {
        if (sel.selectedIndex !== i) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync();
        close(true);
      }

      btn.addEventListener('click', function () {
        if (root.classList.contains('mp-select--open')) close(true);
        else open();
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
      });

      list.addEventListener('keydown', function (e) {
        switch (e.key) {
          case 'ArrowDown': e.preventDefault(); setActive(activeIndex + 1); break;
          case 'ArrowUp':   e.preventDefault(); setActive(activeIndex - 1); break;
          case 'Home':      e.preventDefault(); setActive(0); break;
          case 'End':       e.preventDefault(); setActive(options.length - 1); break;
          case 'Enter':
          case ' ':         e.preventDefault(); choose(activeIndex); break;
          case 'Escape':    e.preventDefault(); e.stopPropagation(); close(true); break;
          case 'Tab':       close(); break;
          default:
            if (e.key.length === 1 && /\S/.test(e.key)) {
              clearTimeout(typeTimer);
              typeahead += e.key.toLowerCase();
              typeTimer = setTimeout(function () { typeahead = ''; }, 500);
              for (var j = 0; j < options.length; j++) {
                if (options[j].textContent.trim().toLowerCase().indexOf(typeahead) === 0) {
                  setActive(j);
                  break;
                }
              }
            }
        }
      });

      sel._mpSelectSync = sync;
      sync();
    }
  }

  enhanceSelects();

  var grid = document.getElementById('mp-products-grid');
  /* ── Le card oltre la cinquantesima ──────────────────────────────────
     Liquid non ne restituisce piu' di 50 per pagina, e il filtro qui sotto
     lavora sul DOM: con 73 prodotti a catalogo, cercare "Pasta fresca" ne
     mostrava uno solo invece di sette, perche' gli altri non erano stati
     nemmeno disegnati.

     Qui si chiedono le pagine successive, si prendono le card gia' pronte
     (stesso snippet Liquid, quindi nessun markup duplicato) e si aggiungono
     alla griglia. Solo dopo parte initProducts, cosi' i filtri nascono
     sapendo di tutti i prodotti.

     Non e' uno scroll infinito, ed e' voluto: il peso vero non sono le card
     ma le immagini, che sono gia' lazy. A 73 prodotti sta in una richiesta
     sola; se un domani diventano molte centinaia, qui sopra si aggiunge il
     caricamento a scaglioni senza toccare altro. */

  function completaOpzioni(select, valori) {
    if (!select) return;
    var presenti = Array.prototype.map.call(select.options, function (o) { return o.value; });
    valori.filter(function (v) { return v && presenti.indexOf(v) === -1; })
          .sort(function (a, b) { return a.localeCompare(b, 'it'); })
          .forEach(function (v) {
            var o = document.createElement('option');
            o.value = v;
            o.textContent = v;
            select.appendChild(o);
          });
  }

  function completaFiltri() {
    var cards = grid.querySelectorAll('.mp-prod-card');
    var tipi = [], tag = [];
    Array.prototype.forEach.call(cards, function (c) {
      var t = (c.getAttribute('data-type') || '').trim();
      if (t && tipi.indexOf(t) === -1) tipi.push(t);
      (c.getAttribute('data-tags') || '').split(',').forEach(function (x) {
        x = x.trim();
        if (x && x.charAt(0) !== '_' && x !== 'marketplace' && tag.indexOf(x) === -1) tag.push(x);
      });
    });
    completaOpzioni(document.getElementById('mp-filter-category'), tipi);
    completaOpzioni(document.getElementById('mp-filter-tags'), tag);
  }

  function caricaTutteLeCard(quandoFinito) {
    var totale = parseInt(grid.getAttribute('data-totale') || '0', 10);
    var perPagina = parseInt(grid.getAttribute('data-per-pagina') || '50', 10);
    var pagine = perPagina > 0 ? Math.ceil(totale / perPagina) : 1;
    if (!(pagine > 1) || typeof fetch !== 'function') { quandoFinito(); return; }

    var attese = [];
    for (var n = 2; n <= pagine; n++) {
      (function (numero) {
        attese.push(
          // Solo la sezione del marketplace, non la pagina intera: 6 KB invece di 62 per
          // le stesse card (misurato il 17/10/2026). Se manca l'id si torna alla pagina intera.
          fetch(location.pathname + '?page=' + numero + (grid.getAttribute('data-sezione') ? '&section_id=' + encodeURIComponent(grid.getAttribute('data-sezione')) : ''), { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) { return { numero: numero, html: html }; })
            .catch(function () { return { numero: numero, html: '' }; })
        );
      })(n);
    }

    Promise.all(attese).then(function (risposte) {
      risposte.sort(function (a, b) { return a.numero - b.numero; }).forEach(function (r) {
        if (!r.html) return;
        var doc = new DOMParser().parseFromString(r.html, 'text/html');
        var nuove = doc.querySelectorAll('#mp-products-grid .mp-prod-card');
        Array.prototype.forEach.call(nuove, function (c) {
          grid.appendChild(document.importNode(c, true));
        });
      });
      completaFiltri();
      // Le card arrivate adesso hanno ancora il <select> nativo: il selettore
      // di marca lo costruisce mp-card-variant.js, che gira una volta sola al
      // caricamento della pagina e queste non le ha mai viste. Senza questa
      // riga meta' marketplace ha la tendina del sistema operativo, con dentro
      // il prezzo al chilo ripetuto, e l'altra meta' quella nostra.
      if (window.mpEnhanceVariantSelects) window.mpEnhanceVariantSelects(grid);
      quandoFinito();
    }).catch(function () { quandoFinito(); });
  }

  if (grid) { caricaTutteLeCard(initProducts); }

  function initProducts() {
    var allCards    = Array.from(grid.querySelectorAll('.mp-prod-card'));
    var countEl     = document.getElementById('mp-products-count');
    var emptyEl     = document.getElementById('mp-products-empty');
    var chipsEl     = document.getElementById('mp-active-filters');
    var sortEl      = document.getElementById('mp-sort');
    var priceEl     = document.getElementById('mp-filter-price');
    var catEl       = document.getElementById('mp-filter-category');
    var tagEl       = document.getElementById('mp-filter-tags');
    var availEl     = document.getElementById('mp-filter-available');
    var resetBtn    = document.getElementById('mp-filters-reset');
    var filtersEl   = document.getElementById('mp-filters');
    var toggleBtn   = document.getElementById('mp-filters-toggle');
    var closeBtn    = document.getElementById('mp-filters-close');

    /* ── Ordine alternato per produttore ─────────────────────────────
       Ogni produttore tiene il suo ordine interno, ma le sue card si
       spargono in modo uniforme lungo la griglia: la k-esima card di un
       produttore con n card va al punto (k + 0,5) / n. Cosi' due card
       vicine sono quasi sempre di produttori diversi, l'ordine e' sempre
       lo stesso a ogni visita, e i prodotti nuovi trovano posto da soli.
       "Rilevanza" nell'ordinamento riporta a quest'ordine. 14/10/2026. */
    (function () {
      var gruppi = {};
      allCards.forEach(function (c) {
        var v = c.getAttribute('data-vendor') || '';
        (gruppi[v] = gruppi[v] || []).push(c);
      });
      var posti = [];
      Object.keys(gruppi).forEach(function (v) {
        var g = gruppi[v];
        g.forEach(function (c, k) { posti.push({ card: c, punto: (k + 0.5) / g.length, produttore: v }); });
      });
      posti.sort(function (a, b) { return a.punto - b.punto || a.produttore.localeCompare(b.produttore, 'it'); });
      posti.forEach(function (p, i) { p.card.dataset.ordine = i; });
    })();

    /* ── Filter + Sort ─────────────────────────────────────────────── */

    function applyFilters() {
      var price = priceEl ? priceEl.value : '';
      var cat   = catEl ? catEl.value : '';
      var tag   = tagEl ? tagEl.value : '';
      var avail = availEl ? availEl.checked : false;
      var pMin  = 0, pMax = Infinity;

      if (price) {
        var parts = price.split('-');
        pMin = parseInt(parts[0], 10) || 0;
        pMax = parts[1] ? parseInt(parts[1], 10) : Infinity;
      }

      var visible = 0;
      allCards.forEach(function (card) {
        var cardPrice = parseInt(card.dataset.price, 10) || 0;
        var cardType  = card.dataset.type || '';
        var cardTags  = card.dataset.tags || '';
        var cardAvail = card.dataset.available === 'true';

        var show = true;
        if (cardPrice < pMin || cardPrice > pMax) show = false;
        if (cat && cardType !== cat) show = false;
        if (tag && cardTags.split(',').indexOf(tag) === -1) show = false;
        if (avail && !cardAvail) show = false;

        card.classList.toggle('mp-prod-card--hidden', !show);
        if (show) visible++;
      });

      if (countEl) countEl.textContent = visible + (visible === 1 ? ' prodotto' : ' prodotti');
      if (emptyEl) emptyEl.style.display = visible === 0 ? '' : 'none';
      if (grid) grid.style.display = visible === 0 ? 'none' : '';

      renderChips(price, cat, tag, avail);
    }

    function applySort() {
      var val = sortEl ? sortEl.value : 'relevance';
      var sorted = allCards.slice();

      sorted.sort(function (a, b) {
        switch (val) {
          case 'price-asc':
            return (parseInt(a.dataset.price, 10) || 0) - (parseInt(b.dataset.price, 10) || 0);
          case 'price-desc':
            return (parseInt(b.dataset.price, 10) || 0) - (parseInt(a.dataset.price, 10) || 0);
          case 'alpha-asc':
            return (a.dataset.title || '').localeCompare(b.dataset.title || '', 'it');
          case 'newest':
            return (b.dataset.created || '').localeCompare(a.dataset.created || '');
          default:
            return (parseInt(a.dataset.ordine, 10) || 0) - (parseInt(b.dataset.ordine, 10) || 0);
        }
      });

      sorted.forEach(function (card) { grid.appendChild(card); });
    }

    /* ── Active filter chips ───────────────────────────────────────── */

    function renderChips(price, cat, tag, avail) {
      if (!chipsEl) return;
      chipsEl.innerHTML = '';

      if (price) addChip(priceEl.options[priceEl.selectedIndex].text, function () { priceEl.value = ''; syncSelect(priceEl); update(); });
      if (cat) addChip(cat, function () { catEl.value = ''; syncSelect(catEl); update(); });
      if (tag) addChip(tag, function () { tagEl.value = ''; syncSelect(tagEl); update(); });
      if (avail) addChip('Solo disponibili', function () { availEl.checked = false; update(); });
    }

    function addChip(label, onClick) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mp-active-chip';
      btn.innerHTML = label + ' <span class="mp-active-chip__x">&times;</span>';
      btn.addEventListener('click', onClick);
      chipsEl.appendChild(btn);
    }

    function update() {
      applyFilters();
      applySort();
    }

    /** Refresh a custom listbox's label after setting select.value directly */
    function syncSelect(s) {
      if (s && s._mpSelectSync) s._mpSelectSync();
    }

    /* ── Event listeners ───────────────────────────────────────────── */

    if (priceEl) priceEl.addEventListener('change', update);
    if (catEl) catEl.addEventListener('change', update);
    if (tagEl) tagEl.addEventListener('change', update);
    if (availEl) availEl.addEventListener('change', update);
    if (sortEl) sortEl.addEventListener('change', function () { applySort(); });
    applySort();

    if (resetBtn) resetBtn.addEventListener('click', function () {
      if (priceEl) { priceEl.value = ''; syncSelect(priceEl); }
      if (catEl) { catEl.value = ''; syncSelect(catEl); }
      if (tagEl) { tagEl.value = ''; syncSelect(tagEl); }
      if (availEl) availEl.checked = false;
      update();
    });

    /* ── Mobile filter drawer ──────────────────────────────────────── */

    if (toggleBtn && filtersEl) {
      toggleBtn.addEventListener('click', function () {
        filtersEl.classList.add('mp-filters--open');
        document.body.style.overflow = 'hidden';
      });
    }

    function closeFilters() {
      if (filtersEl) filtersEl.classList.remove('mp-filters--open');
      document.body.style.overflow = '';
      document.dispatchEvent(new Event('mp:close-selects'));
    }

    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (filtersEl) filtersEl.addEventListener('click', function (e) {
      if (e.target === filtersEl) closeFilters();
    });

    /* ── Product add-to-cart ───────────────────────────────────────── */

    grid.addEventListener('click', async function (e) {
      var btn = e.target.closest('.mp-prod-card__add');
      if (!btn || btn.disabled) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('mp-prod-card__add--loading');
      var origText = btn.textContent;
      btn.textContent = 'Aggiunta...';
      btn.disabled = true;

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { '_vendor_group': btn.closest('.mp-prod-card').getAttribute('data-vendor') || '' } }] }),
        });

        if (!res.ok) {
          var err = await res.json().catch(function () { return {}; });
          throw new Error(err.description || 'Errore');
        }

        var cartRes = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
        var cart = cartRes.ok ? await cartRes.json() : null;
        dispatchCartUpdate(cart, 0);
        showToast('Prodotto aggiunto al carrello');

      } catch (e) {
        showToast(e.message || 'Errore: riprova', true);
      } finally {
        btn.classList.remove('mp-prod-card__add--loading');
        btn.textContent = origText;
        btn.disabled = false;
      }
    });
  }

});
